
import XHeader from 'vux/src/components/x-header/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import AlertModule from 'vux/src/plugins/alert/module'

import global from '../../../static/js/global'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
beforeMount(){
if(this.$router.history.current.path == "/momentsdetail"){
document.title = "邻里分享";
}
this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
},
methods:{
reduce(){
let img = document.getElementById('bigpic');
if(this.current > 0){
this.current--;
}else{
this.current = 0;
}
this.imgsrc=this.data.imgs[this.current].maxPicUrl;
let self = this;
img.onload = function () {
self.top = (document.getElementById('view_01').clientHeight - this.height ) / 2;
$(this).animate({'opacity':+1},1,'swing');
}
},
add(){
if(this.current < this.data.imgs.length-1){
this.current++;
}else{
this.current = this.data.imgs.length-1;
}
let img = document.getElementById('bigpic');
this.imgsrc=this.data.imgs[this.current].maxPicUrl;
let self = this;
img.onload = function () {
self.top = (document.getElementById('view_01').clientHeight - this.height ) / 2;
$(this).animate({'opacity':+1},1,'swing');
}
},
viewBigPic(current){
this.preview = true;
this.current = current;
let img = document.getElementById('bigpic');
this.imgsrc=this.data.imgs[this.current].maxPicUrl;
let self = this;
img.onload = function () {
self.top = (document.getElementById('view_01').clientHeight - this.height ) / 2;
$(this).animate({'opacity':+1},2,'swing');
}
},
hideBigPic(){
this.preview = false;
},
discussinfo(){

this.parentId = 0;
this.parentman = '';
this.typeopera = '评论';
this.placeholder = '我要发表评论';
},
revert(index){

this.parentId = this.replylist[index].msgId;
this.parentman = this.replylist[index].pushMan;
this.typeopera = '回复';
this.placeholder = `我要回复${this.parentman}的评论`;
},
like(){
this.data.praisePoint += 1;
this.$http.get(global.host + 'themeShare/like?themeId='+this.$router.history.current.query.themeId,{header:{Accept: "application/x-www-form-urlencoded"}}).then(function(res){

},function(err){
console.log(err)
})
},
submitComment(){
if(!this.comment){
AlertModule.show({
title: '温馨提示',
content: `请输入你要${this.typeopera}的留言`,
})
}else{
this.forbid = true;
let self = this;
let data = {message: this.comment,"parentId": this.parentId,parentman: this.parentman,regPhone: this.$router.history.current.query.phone,themeId: this.$router.history.current.query.themeId};
this.$http.post(global.host + 'themeShare/insertMsg',data,{header:{Accept: "application/x-www-form-urlencoded"}}).then(function(res){
if(res.body.statusCode == '110'){
this.comment = '';
this.placeholder = '留言成功'
this.$http.get(global.host + 'themeShare/getThemeDetail?themeId='+this.$router.history.current.query.themeId,{header:{Accept: "application/x-www-form-urlencoded"}}).then(function(res){
if(res.result.statusCode == '110'){
this.data.msgCount = (isNaN(parseInt(res.body.result.msgCount)) ? 0 : parseInt(res.body.result.msgCount));
}
},function(err){console.log(err)})
this.$http.get(global.host + 'themeShare/getMsgBody?themeId='+this.$router.history.current.query.themeId,{header:{Accept: "application/x-www-form-urlencoded"}}).then(function(res){
if(res.body.result){
let size = self.replylist.length;
for(let i = 0 ; i < size ; i ++){
self.replylist.pop();
}
size =  res.body.result.length;
for(let i = 0 ; i < size ; i ++){
self.replylist.push(res.body.result[i])
}
}
},function(err){console.log(err)})
}
},function(err){console.log(err)})
}
}
},
beforeMount(){
this.$http.get(global.host + 'themeShare/getThemeDetail?themeId='+this.$router.history.current.query.themeId,{header:{Accept: "application/x-www-form-urlencoded"}}).then(function(res){

if(res.body.result){
this.data = res.body.result;
this.data.praisePoint = (isNaN(parseInt(this.data.praisePoint))? 0 : parseInt(this.data.praisePoint));
this.data.msgCount = (isNaN(parseInt(this.data.msgCount)) ? 0 : parseInt(this.data.msgCount));
if(this.data.imgs.length > 0){
for(let j = 0 ; j < this.data.imgs.length; j++){
this.data.imgs[j].maxPicUrl = global.baseImg + this.data.imgs[j].maxPicUrl;
this.data.imgs[j].minPicUrl = global.baseImg + this.data.imgs[j].minPicUrl;
}
}
}else{
this.data.themeDesc = '你参与的此话题已删除';
this.data.memberName = '';
this.data.comnName = ''
this.data.msgCount = 0;
this.data.praisePoint = 0;
}

},function(err){console.log(err)})

this.$http.get(global.host + 'themeShare/getMsgBody?themeId='+this.$router.history.current.query.themeId,{header:{Accept: "application/x-www-form-urlencoded"}}).then(function(res){
if(res.body.result){
this.replylist = res.body.result;
}
},function(err){console.log(err)})
},
data(){
return{
data:'',
top:0,
comment:'',
replyable:true,
replylist:[],
parentId:0,
parentman:'',
typeopera:'评论',
placeholder:'我要发表评论',
forbid:false,
preview:false,
maxheight:window.screen.height - 43,
imgsrc:'',
current:0
}
},
components:{XHeader,XImg,Flexbox,FlexboxItem,XButton,XInput}
}



// WEBPACK FOOTER //
// ./src/components/momentsComponents/detail.vue